import React from "react";
import AccessoryCheckBoxes from "../components/AccessoryCheckBoxes";
import AccessoryCheckBoxesSkeleton from "../components/AccessoryCheckBoxesSkeleton";

import useAccessories from "../hooks/useAccessories";
import { isError } from "util";

const Accessories = ({ field, trimId, ...props }) => {
  const [accessories] = useAccessories({ trimId });

  if (!accessories) {
    return <AccessoryCheckBoxesSkeleton />;
  }

  if (isError(accessories)) {
    return <></>;
  }

  return <AccessoryCheckBoxes items={accessories} {...field} {...props} />;
};

export default Accessories;
